import 'slideout/index.css';
import '../css/theme.css';
import '@splidejs/splide/dist/css/splide.min.css';
// import { Slideout } from './modules/Slideout';
import { LazyLoader } from './modules/LazyLoader';
import { Theme } from './classes/Theme';
import { Pagination } from './modules/Pagination';
import { Accordion } from './modules/Accordion';
import { AddToCart } from './modules/AddToCart';
import { Quantity } from './modules/Quantity';
import { ProductGallery } from './modules/ProductGallery';
import Tabs from './modules/Tabs';
document.addEventListener('DOMContentLoaded', function () {
    window.theme = new Theme({
        lazyLoader: new LazyLoader(),
        // slideout: new Slideout(),
        pagination: new Pagination(),
        accordion: new Accordion(),
        addToCart: new AddToCart(),
        quantity: new Quantity(),
        productGallery: new ProductGallery(),
        tabs: new Tabs(),
    });
    window.theme.load();
});
